import apiHeader from '@/helpers/apiHeader';

const transactionLogService = {
  // New unified list method following clients.vue style
  list(payload, params) {
    return apiHeader.post('report/transaction-log', payload, { params });
  },
  export() {
    return apiHeader.get(`report/transaction-log/export`, {
      responseType: 'blob', // Pastikan untuk meminta blob
    });
  },
  tracking(payload, params) {
    return apiHeader.post('report/transaction-log', payload, { params });
  },

  nextApproval(payload) {
    return apiHeader.post('report/transaction-log/next-approval', payload);
  },
};

export default transactionLogService;
